export default __webpack_public_path__ + "static/media/Creative2.cba41660.png";